import { SearchBar } from 'antd-mobile';
import { useState } from 'preact/hooks';

const Search = ({ onSearch, onClear }) => {

    const [value, setValue] = useState('');

    const onChange = (e) => {
        setValue(e);
        if (e.length === 0) onClear();
    }
    return (
        <SearchBar
            value={value}
            onSearch={() => {
                if (value.length > 0) onSearch(value);
            }}
            onChange={onChange}
            placeholder={'请输入商品信息'} style={{ margin: '0px 15px', '--border-radius': '50px', marginTop: '10px' }} />
    )
}

export default Search;